import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout.tsx";
import { Users } from "../pages/Users.tsx";
import Reports from "../pages/Reports.tsx";
import CareNotesReports from "../pages/CareNotesReports.js";
import Medication from "../pages/Medication.js";
import { ServiceUserDetails } from "../pages/ServiceUserDetails.tsx";
import { Templates } from "../pages/Templates.tsx";
import { TemplatesDetails } from "../pages/TemplatesDetails.tsx";
import { UserTemplates } from "../pages/UserTemplates.tsx";
import { TemplateFormView } from "../pages/TemplateForm.tsx";
import { Settings } from "../pages/Settings.tsx";
import { StaffDetails } from "../pages/StaffDetails.tsx";
import Shifts from "../pages/Shifts.js";
import Login from "../pages/Login.js";
import { lazy, Suspense } from "react";
import PrivateRoute from "./PrivateRoute.js";
import AuthRoute from "./AuthRoute.js";
import Admin from "../pages/Admin.js";
import Documents from "../pages/Documents.js";
import { FieldShifts } from "../pages/FieldShifts.js";
import { FieldShiftsDetails } from "../pages/FieldShiftsDetails.js";
import { UserMedications } from "../pages/UserMedications.js";
import { FieldShiftMedication } from "../pages/FieldShiftMedication.js";
import { PRN } from "../pages/PRN.js";
import { FieldShiftPRN } from "../pages/FieldShiftPRN.js";
import { ShiftDetails } from "../pages/ShiftDetails.js";

const Dashboard = lazy(() => import("../pages/Dashboard"));

const SysRoutes = () => {
  return (
    <Router>
      <Suspense>
        <Routes>
          {/* Private Routes */}
          <Route element={<PrivateRoute />}>
            <Route
              path="/dashboard"
              element={
                <DashboardLayout pageTitle="Dashboard">
                  <Dashboard />
                </DashboardLayout>
              }
            />
            <Route
              path="/users"
              element={
                <DashboardLayout pageTitle="Users">
                  <Users />
                </DashboardLayout>
              }
            />
            <Route
              path="/service-user/:id"
              element={
                <DashboardLayout pageTitle="Service user">
                  <ServiceUserDetails />
                </DashboardLayout>
              }
            />
            <Route
              path="/team-member/:id"
              element={
                <DashboardLayout pageTitle="Team member">
                  <StaffDetails />
                </DashboardLayout>
              }
            />
            <Route
              path="/users/:id/template"
              element={
                <DashboardLayout pageTitle="User Templates">
                  <UserTemplates />
                </DashboardLayout>
              }
            />
            <Route
              path="/users/:id/template/form"
              element={
                <DashboardLayout pageTitle="Add Template">
                  <TemplateFormView />
                </DashboardLayout>
              }
            />
            <Route
              path="/reports"
              element={
                <DashboardLayout pageTitle="Reports">
                  <Reports />
                </DashboardLayout>
              }
            />
            <Route
              path="/reports/care-notes"
              element={
                <DashboardLayout pageTitle="Care Notes Reports">
                  <CareNotesReports />
                </DashboardLayout>
              }
            />
            <Route
              path="/rotas"
              element={
                <DashboardLayout pageTitle="Shifts">
                  <Shifts />
                </DashboardLayout>
              }
            />
            <Route
              path="/medication"
              element={
                <DashboardLayout pageTitle="Medication">
                  <Medication />
                </DashboardLayout>
              }
            />
            <Route
              path="/templates"
              element={
                <DashboardLayout pageTitle="Templates">
                  <Templates />
                </DashboardLayout>
              }
            />
            <Route
              path="/template/:id"
              element={
                <DashboardLayout pageTitle="Templates">
                  <TemplatesDetails />
                </DashboardLayout>
              }
            />
            <Route
              path="/settings"
              element={
                <DashboardLayout pageTitle="Settings">
                  <Settings />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin"
              element={
                <DashboardLayout pageTitle="Admin">
                  <Admin />
                </DashboardLayout>
              }
            />
            <Route
              path="/documents/:id"
              element={
                <DashboardLayout pageTitle="Documents">
                  <Documents />
                </DashboardLayout>
              }
            />
            <Route
              path="/field-shifts"
              element={
                <DashboardLayout pageTitle="">
                  <FieldShifts />
                </DashboardLayout>
              }
            />
            <Route
              path="/field-shifts/:id/:serviceUserId"
              element={
                <DashboardLayout pageTitle="">
                  <FieldShiftsDetails />
                </DashboardLayout>
              }
            />

            <Route
              path="/field-shifts/:id/medication/:serviceUserId"
              element={
                <DashboardLayout pageTitle="">
                  <FieldShiftMedication />
                </DashboardLayout>
              }
            />

            <Route
              path="/field-shifts/:id/prn/:serviceUserId"
              element={
                <DashboardLayout pageTitle="">
                  <FieldShiftPRN />
                </DashboardLayout>
              }
            />

            <Route
              path="/user-medication/:id"
              element={
                <DashboardLayout pageTitle="">
                  <UserMedications />
                </DashboardLayout>
              }
            />

            <Route
              path="/prn/:id"
              element={
                <DashboardLayout pageTitle="">
                  <PRN />
                </DashboardLayout>
              }
            />

            <Route
              path="/shift/:id"
              element={
                <DashboardLayout pageTitle="">
                  <ShiftDetails />
                </DashboardLayout>
              }
            />
          </Route>

          {/* Public Routes */}
          <Route element={<AuthRoute />}>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
};

export default SysRoutes;
